import React, { useEffect, useState, useMemo, useRef } from "react";
import Header from "../../../Componets/Header";
import Loadercomponent from "../../../Componets/Loader";
import toast from "react-hot-toast";
import { Button, Tag, Table, Card, Select, DatePicker, Space, Statistic, Timeline } from "antd";
import {
  StockOutlined,
  StockInOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  SwapOutlined,
  FileTextOutlined,
  ReloadOutlined,
  PrinterOutlined,
  DownloadOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ReactToPrint from "react-to-print";
import {
  get_comprehensive_product_reports
} from "../../../Controllers/Dashboard/Dashboard";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import formatDateDDMMYYYY from "../../../Main/formatDate";
import { resolveTransactionType } from "../../../Main/resolveTransactionType";
const { RangePicker } = DatePicker;
const { Option } = Select;

const StockLedgerReport = () => {
  const [loader, setLoader] = useState(false);
  const [stockData, setStockData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("all");
  const [dateRange, setDateRange] = useState([]);
  const [transactionType, setTransactionType] = useState("all");
  const componentRef = useRef();
  const tableRef = useRef();

  const headers = {
    name: "Stock Ledger Report",
    components: [
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "Stock Ledger",
          path: ""
        }
      ],
      total: [
        { value: 0, label: "Total Transactions" },
        { value: 0, label: "Inflow" },
        { value: 0, label: "Outflow" },
      ],
    },
  };

  const [header, setHeader] = useState(headers);

  const computeQuantity = (type, quantity, isDelete = false) => {
    switch (type) {
      case "inventory":
        return isDelete ? -Math.abs(quantity) : Math.abs(quantity);
      case "purchase":
        return isDelete ? -Math.abs(quantity) : Math.abs(quantity);
      case "purchase_return":
        return isDelete ? Math.abs(quantity) : -Math.abs(quantity);
      case "transfer":
        return isDelete ? Math.abs(quantity) : -Math.abs(quantity);
      case "sale":
        return -Math.abs(quantity);
      case "sales_return":
        return Math.abs(quantity);
      default:
        return quantity;
    }
  };

  const processStockData = (apiData) => {
    const stockEntries = [];
    let productList = new Set();
    

    const addEntry = (type, item, quantity, date, info, details = {}) => {

      console.log("add entry", type, item, quantity);

      const entryDate = new Date(item.created || item.createdAt || item.date || Date.now());
      const formattedDate = dayjs(entryDate).format("YYYY-MM-DD HH:mm:ss");

      const { action, entity } = resolveTransactionType(info?.endpoint);

      const transactionLabel =
        action !== "UNKNOWN"
          ? `${action.replace("_", " ")} ${entity.replace("_", " ")}`
          : type.replace("_", " ").toUpperCase();

      stockEntries.push({
        key: `${type}_${item._id}_${entryDate.getTime()}`,
        date: formattedDate,
        timestamp: entryDate,
        type: transactionLabel,
        productName: item.name || item.product?.name || info.name || "N/A",
        batchNumber: info?.number || info?.inventory?.number || "N/A",
        endpoint: info?.endpoint,
        expiryDate: info?.expiry_date
          ? dayjs(info.expiry_date).format("YYYY-MM-DD")
          : info?.inventory?.expiry_date
            ? dayjs(info.inventory.expiry_date).format("YYYY-MM-DD")
            : "N/A",
        productId: item._id || item.product?._id,
        reference: item.number || item.invoice || `#${type.slice(0, 3).toUpperCase()}`,
        quantity: Math.abs(quantity),
        movement: quantity > 0 ? "in" : "out",
        unit: "pcs",
        details: details,
        user: item.user?.name || "System",
        branch: item.branch?.name || "Main Branch"
      });

      productList.add(item.name || item.product?.name || details.productName);
    };

    if (apiData.data?.product_details) {
      apiData.data.product_details.forEach(product => {
        addEntry("product_created", product, 0, product.created, product, {
          operation: "Product Created",
          price: product.sale_price,
          status: product.status === 1 ? "Active" : "Inactive"
        });
      });
    }

    if (apiData.data?.inventory_details) {
      apiData.data.inventory_details.forEach(inv => {
        const isDeleted = inv.endpoint === "/api/delete-inventory" === true || false;
        const quantity = computeQuantity("inventory", inv.stock, isDeleted);
        addEntry("inventory", inv, quantity, inv.createdAt, inv, {
          operation: "Stock Addition",
          purchasePrice: inv.purchase_price,
          salePrice: inv.sale_price,
          expiry: inv.expiry_date ? dayjs(inv.expiry_date).format("YYYY-MM-DD") : null
        });
      });
    }

    if (apiData.data?.sales_details) {
      apiData.data.sales_details.forEach(sale => {
        sale.details?.forEach(detail => {
          const isDeleted = sale.endpoint === "/api/delete-invoice" === true || false;
          const quantity = computeQuantity("sale", detail.quantity, isDeleted);
          addEntry("sale", sale, quantity, sale.date, detail, {
            operation: "Sales Invoice",
            invoiceNumber: sale.number,
            customer: sale.customer?.name || "Walk-in Customer",
            amount: sale.total
          });
        });
      });
    }

    if (apiData.data?.sales_return_details) {
      apiData.data.sales_return_details.forEach(returnItem => {
        returnItem.details?.forEach(detail => {
          const isDeleted = returnItem.endpoint === "/api/delete-sales-return" === true || false;
          const quantity = computeQuantity("sales_return", detail.quantity, isDeleted);
          addEntry("sales_return", returnItem, quantity, returnItem.date, detail, {
            operation: "Sales Return",
            returnNumber: returnItem.number,
            reason: "Customer Return"
          });
        });
      });
    }

    if (apiData.data?.purchase_order_details) {
      apiData.data.purchase_order_details.forEach(purchase => {
        purchase.details?.forEach(detail => {
          const isDeleted = purchase.endpoint === "/api/delete-purchase-order" === true || false;
          const quantity = computeQuantity("purchase", detail.quantity, isDeleted);
          addEntry("purchase", purchase, quantity, purchase.date, detail, {
            operation: "Purchase Order",
            purchaseNumber: purchase.number,
            supplier: purchase.supplier?.name || "Supplier",
            amount: purchase.total
          });
        });
      });
    }

    if (apiData.data?.purchase_return_details) {
      apiData.data.purchase_return_details.forEach(returnItem => {
        returnItem.details?.forEach(detail => {
          const isDeleted = returnItem.endpoint === "/api/delete-purchases-return" === true || false;
          const quantity = computeQuantity("purchase_return", detail.quantity, isDeleted);
          addEntry("purchase_return", returnItem, quantity, returnItem.date, detail, {
            operation: "Purchase Return",
            returnNumber: returnItem.number,
            supplier: returnItem.supplier?.name || "Supplier"
          });
        });
      });
    }

    if (apiData.data?.transfer_details) {
      apiData.data.transfer_details.forEach(transfer => {
        transfer.details?.forEach(detail => {
          const isDeleted = transfer.endpoint === "/api/delete-transfer" === true || false;
          const quantity = computeQuantity("transfer", detail.quantity, isDeleted);
          addEntry("transfer", transfer, quantity, transfer.date, detail, {
            operation: "Stock Transfer",
            transferNumber: transfer.number,
            toBranch: transfer.supplier_branch?.name || "Other Branch",
            status: transfer.delivery_status === 2 ? "Delivered" : "Pending"
          });
        });
      });
    }

    stockEntries.sort((a, b) => a.timestamp - b.timestamp);

    setProducts([...productList].map(name => ({ value: name, label: name })));

    return stockEntries;
  };

  const fetchStockData = async () => {
    try {
      setLoader(true);
      const StockMovementAPIReponse = await get_comprehensive_product_reports();

      const processedData = processStockData(StockMovementAPIReponse.data);

      console.log("Ssssss", processedData)
      setStockData(processedData);
      setFilteredData(processedData);

      const inflow = processedData.filter(d => d.movement === "in").length;
      const outflow = processedData.filter(d => d.movement === "out").length;

      setHeader(prev => ({
        ...prev,
        navigate: {
          ...prev.navigate,
          total: [
            { value: processedData.length, label: "Total Transactions" },
            { value: inflow, label: "Inflow" },
            { value: outflow, label: "Outflow" },
          ],
        },
      }));

      setLoader(false);
    } catch (error) {
      toast.error(error.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchStockData();
  }, []);

  useEffect(() => {
    let filtered = [...stockData];

    if (selectedProduct !== "all") {
      filtered = filtered.filter(item => item.productName === selectedProduct);
    }

    if (transactionType !== "all") {
      filtered = filtered.filter(item => item.type.includes(transactionType));
    }

    if (dateRange && dateRange.length === 2) {
      const startDate = dayjs(dateRange[0]).startOf('day');
      const endDate = dayjs(dateRange[1]).endOf('day');
      filtered = filtered.filter(item => {
        const itemDate = dayjs(item.timestamp);
        return itemDate.isAfter(startDate) && itemDate.isBefore(endDate);
      });
    }

    setFilteredData(filtered);
  }, [selectedProduct, transactionType, dateRange, stockData]);

  const columns = [
    {
      title: 'Date & Time',
      dataIndex: 'date',
      key: 'date',
      width: 160,
      sorter: (a, b) => new Date(a.timestamp) - new Date(b.timestamp),
    },
    {
      title: 'Product',
      dataIndex: 'productName',
      width: 180,
      render: (_, record) => {
        return (
          <div className="text-xs">
            <div><strong>Product:</strong> {record.productName}</div>
            <div><strong>Batch:</strong> {record.batchNumber}</div>
            <div><strong>Expiry Date:</strong> {record.expiryDate}</div>
            <div><strong>End Point:</strong> {record.endpoint}</div>
          </div>
        );
      },
    },
    {
      title: "Transaction Type",
      dataIndex: "type",
      key: "type",
      render: (text) => <Tag color="blue">{text}</Tag>
    },
    {
      title: 'Movement',
      dataIndex: 'movement',
      key: 'movement',
      width: 100,
      render: (movement, record) => (
        <div className="flex items-center">
          {movement === 'in' ? (
            <>
              <ArrowUpOutlined className="text-green-600 mr-1" />
              <span className="text-green-600">+{record.quantity}</span>
            </>
          ) : (
            <>
              <ArrowDownOutlined className="text-red-600 mr-1" />
              <span className="text-red-600">-{record.quantity}</span>
            </>
          )}
        </div>
      ),
    },
    {
      title: 'User',
      dataIndex: 'user',
      key: 'user',
      width: 120,
    },
    {
      title: 'Branch',
      dataIndex: 'branch',
      key: 'branch',
      width: 120,
    },
    {
      title: 'Details',
      key: 'details',
      width: 200,
      render: (_, record) => {
        const details = record.details;
        return (
          <div className="text-xs">
            <div>
              <strong>Op:</strong>{" "}
              {record.type
                .replace(/_/g, " ")
                .toLowerCase()
                .replace(/\b\w/g, char => char.toUpperCase())}
            </div>
            {details.invoiceNumber && <div><strong>Inv:</strong> {details.invoiceNumber}</div>}
            {details.amount && <div><strong>Amt:</strong> {details.amount}</div>}
            {details.supplier && <div><strong>Supplier:</strong> {details.supplier}</div>}
          </div>
        );
      },
    },
  ];

  const downloadPDF = () => {
    const doc = new jsPDF('landscape');

    doc.setFontSize(16);
    doc.text('Stock Ledger Report', 14, 15);
    doc.setFontSize(10);
    doc.text(`Generated on: ${dayjs().format('YYYY-MM-DD HH:mm:ss')}`, 14, 22);

    const tableData = filteredData.map((item, index) => [
      index + 1,
      item.date,
      item.productName,
      item.type.replace('_', ' ').toUpperCase(),
      item.reference,
      item.movement === 'in' ? `+${item.quantity}` : `-${item.quantity}`,
      item.user,
      item.branch
    ]);

    autoTable(doc, {
      startY: 30,
      head: [['#', 'Date', 'Product', 'Type', 'Ref', 'Qty',  'User', 'Branch']],
      body: tableData,
      theme: 'grid',
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255 }
    });

    doc.save(`stock-ledger-${dayjs().format('YYYY-MM-DD')}.pdf`);
  };

  const downloadCSV = () => {
    const headers = ['Date', 'Product', 'Type', 'Reference', 'Movement', 'Quantity', 'Balance', 'User', 'Branch', 'Details'];

    const csvData = filteredData.map(item => [
      item.date,
      item.productName,
      item.type,
      item.reference,
      item.movement,
      item.quantity,
      item.balance,
      item.user,
      item.branch,
      JSON.stringify(item.details)
    ]);

    const csvContent = [headers, ...csvData]
      .map(row => row.map(cell => `"${cell}"`).join(','))
      .join('\n');

    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `stock-ledger-${dayjs().format('YYYY-MM-DD')}.csv`;
    link.click();
  };

  const getTransactionStats = () => {
    const stats = {
      total: filteredData.length,
      inflow: filteredData.filter(d => d.movement === 'in').length,
      outflow: filteredData.filter(d => d.movement === 'out').length,
      totalQtyIn: filteredData.filter(d => d.movement === 'in').reduce((sum, d) => sum + d.quantity, 0),
      totalQtyOut: filteredData.filter(d => d.movement === 'out').reduce((sum, d) => sum + d.quantity, 0),
    };

    return stats;
  };

  const stats = getTransactionStats();

  return (
    <Header headers={header} setHeaders={setHeader}>
      <Loadercomponent loader={loader}>
        <div className="flex justify-end gap-2 mt-4">
          <Button
            icon={<DownloadOutlined />}
            onClick={downloadCSV}
          >
            CSV
          </Button>
          <Button
            icon={<PrinterOutlined />}
            onClick={downloadPDF}
          >
            PDF
          </Button>
        </div>
        <ScrollWrapper>

          <div ref={tableRef}>
            <Table
              columns={columns}
              dataSource={filteredData}
              pagination={false}
              scroll={{ x: 1300 }}
              size="middle"
            />
          </div>

        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default StockLedgerReport;